export function inViewport() {
  const animatedElements = document.querySelectorAll(
    '._js_inViewport',
  );
  const obsCallback = function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.target.classList.contains('_js_inViewport')) {
          entry.target.classList.add('__js_onScreen');
        }
      } else if (
        entry.target.classList.contains('_js_inViewport')
          && entry.target.classList.contains('__js_onScreen')
      ) {
        // entry.target.classList.remove('__js_onScreen');
        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(obsCallback, {
    root: null,
    threshold: 0,
    // rootMargin: '-10px',
  });

  animatedElements.forEach((elem) => {
    observer.observe(elem);
  });
}
